import {deviceTabs,hasFeature} from './device-profile.js';
export function overviewActions(device){
 if(!device)return [];
 const gps=device.profile?.protocol==='gt06',items=[];
 if(gps&&hasFeature(device,'position'))items.push({id:'position',label:'Position',icon:'position',tab:'position'});
 if(hasFeature(device,'calling'))items.push({id:'call',label:'Ring',icon:'call',call:true});
 if(hasFeature(device,'find'))items.push({id:'find',label:'Find',icon:'find-device',screen:'device-find'});
 if(hasFeature(device,'history'))items.push({id:'route',label:'Rute',icon:'route',screen:'position-route'});
 if(gps)items.push({id:'features',label:'Funktioner',icon:'device',tab:'device'});
 // Care is the useful fourth action when registered; every device has Events.
 const care=!gps&&deviceTabs(device).includes('care');
 items.push({id:care?'care':'events',label:care?'Omsorg':'Hændelser',icon:care?'care':'events',tab:care?'care':'events'});
 return items;
}
